var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossBrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99984C18.3334 14.6019 14.6022 18.3332 10.0001 18.3332C5.398 18.3332 1.66675 14.6019 1.66675 9.99984C1.66675 5.39775 5.398 1.6665 10.0001 1.6665C14.6022 1.6665 18.3334 5.39775 18.3334 9.99984Z",
    fill: "#F9DB9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5351 7.64318L12.3568 6.46484L10.0001 8.82151L7.64342 6.46484L6.46509 7.64318L8.82175 9.99984L6.46509 12.3565L7.64342 13.5348L10.0001 11.1782L12.3568 13.5348L13.5351 12.3565L11.1784 9.99984L13.5351 7.64318Z",
    fill: "#916208"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrown);
export default __webpack_public_path__ + "static/media/cross-brown.c6b79fa52876720790fafd8f4c5ecb24.svg";
export { ForwardRef as ReactComponent };